import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dao-switch',
  templateUrl: './dao-switch.component.html',
  styleUrls: ['./dao-switch.component.css']
})
export class DaoSwitchComponent implements OnInit, OnChanges {
  @Input('label') label: string;
  @Input('note') note: string;
  @Input('options') options: any[];
  @Input('Value') Value: string;
  @Input('checked') checked: boolean;
  @Input('required') required: boolean;
  @Input('disabled') disabled: boolean;
  @Input('trueValue') trueValue: string;
  @Input('falseValue') falseValue: string;

  @Output() ValueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() SelectionChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
    this.setDefaultValue();
  }
  setDefaultValue() {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Value) {
      if (changes.Value.currentValue != changes.Value.previousValue) {
        if (this.options) {
          this.setCheckedFromValue(changes.Value.currentValue);
        }
        else {
          this.checked = changes.Value.currentValue;
        }
      }
      if (changes.options && this.Value) {
        this.setCheckedFromValue(this.Value);
      }
    }
  }

  setCheckedFromValue(value: any) {
    let checkedValue = false;
    let selectedOption = this.options.find(x => x.LookupId == value);
    if (selectedOption) {
      if (selectedOption.HiddenValue == this.trueValue) {
        checkedValue = true;
      }
    }
    this.checked = checkedValue;
    this.updateFunc({ checked: checkedValue });
  }



  updateFunc(e) {
    if (this.options) {
      let optionValue;
      if (e.checked === true) {
        optionValue = this.options.find(item => {
          return item.HiddenValue == this.trueValue;
        }).LookupId;
      } else {
        optionValue = this.options.find(item => {
          return item.HiddenValue == this.falseValue;
        }).LookupId;
      }
      if (optionValue) {
        this.Value = optionValue;
      }
      console.log(this.Value);
      this.ValueChange.emit(this.Value);
    }
    this.SelectionChange.emit({ value: this.Value, checked: e.checked });
  }
  onChanged() {
    this.ValueChange.emit(this.Value);
  }

}
